import { variacao } from '../lib/formato';

interface Props {
  titulo: string;
  valor: string;
  /** Linha de apoio embaixo do número (ex.: quantidade quando o número é valor). */
  apoio?: string;
  atual: number;
  anterior: number;
  /** Quando subir é ruim (ex.: saques), a cor da variação inverte. */
  subirEhRuim?: boolean;
  explicacao: string;
}

export function Kpi({ titulo, valor, apoio, atual, anterior, subirEhRuim, explicacao }: Props) {
  const v = variacao(atual, anterior);
  const bom = v.sentido === 'sobe' ? !subirEhRuim : v.sentido === 'desce' ? Boolean(subirEhRuim) : null;
  return (
    <article className="kpi">
      <h3>{titulo}</h3>
      <p className="kpi-valor">{valor}</p>
      {apoio && <p className="kpi-apoio">{apoio}</p>}
      <p className={`kpi-var ${bom === null ? 'neutro' : bom ? 'bom' : 'ruim'}`}>{v.texto}</p>
      <p className="kpi-expl">{explicacao}</p>
    </article>
  );
}
